import gallery from './gallery';

const translations = {
  // SEO
  application: {
    title: "Shopee Indonesia National Data Science Challenge 2020",
    desc:
      "selama satu hari. Kompetisi ini terdiri dari dua babak pemecahan masalah Data Science dan Data Analitik yang dibuat oleh tim Tech Shopee. Para peserta harus menganalisis set data, membuat kesimpulan yang cerdas dan memecahkan masalah dalam rentang waktu yang telah ditentukan. Tidak ada biaya registrasi dan terbuka untuk para pekerja yang bergerak di bidang teknologi maupun non-teknologi yang bekerja di Indonesia dan juga pelajar yang saat ini terdaftar di Sekolah Menengah Atas (SMA), Sekolah Menengah Kejuruan (SMK), atau Universitas di Indonesia (termasuk siswa pertukaran pelajar). Bentuklah tim yang beranggotakan 2-4 orang dan dapatkan kesempatan untuk memenangkan uang tunai dengan total 100 juta rupiah! Cukup daftarkan diri dan nikmati acaranya! ",
    siteURL: "https://careers.shopee.id/ndsc",
    siteImageURL: "https://careers.shopee.id/ndsc/images/ndsc_id_cover.jpg",
    seoStartdate: "2020-02-29 T00:00+07:00",
    seoEnddate: "2020-03-28 T23:59+07:00",
    seoPerformer: "Shopee Indonesia",
    seolocationName: "Shopee Indonesia",
    seolocationAddress: "ndsc.id@shopee.com",
    seohasMap: "",
    seoAudienceType: "Para pekerja dan pelajar yang tertarik dengan Data!",
  },
  // Nav
  navbar: [{
    name: 'ndsc_nav_about',
    href: '#about'
  }, {
    name: 'ndsc_nav_prizes',
    href: '#prizes'
  }, {
    name: 'ndsc_nav_timeline',
    href: '#timeline'
  }, {
    name: 'ndsc_nav_partners',
    href: '#partners'
  }, {
    name: 'ndsc_nav_faq',
    href: '#faq'
  }, {
    name: 'ndsc_nav_contact',
    href: '#contact'
  }, {
    name: 'ndsc_nav_career',
    link: 'https://careers.shopee.co.id/'
  }],
  //Hero
  dateRange: "ndsc_banner_dateRange",
  heroDesc: "ndsc_banner_heroDesc",
  //Intro
  intro: {
    title: "ndsc_intro_title",
    desc: [{
      text: "ndsc_intro_desc_text_1",
      list: [
        "ndsc_intro_desc_text_1_1",
        "ndsc_intro_desc_text_1_2",
        "ndsc_intro_desc_text_1_3"
      ]
    }, {
      text: "ndsc_intro_desc_text_2"
    }]
  },
  about: {
    title: "ndsc_about_title",
    desc: [
      "ndsc_about_desc_1",
      "ndsc_about_desc_2"
    ],
    data: [
      {
        title: "ndsc_about_data_title_1",
        image: "icon_atom.svg",
        desc:
          "ndsc_about_data_desc_1"
      },
      {
        title: "ndsc_about_data_title_2",
        image: "icon_cube_molecule.svg",
        desc:
          "ndsc_about_data_desc_2_1",
        desc02: "ndsc_about_data_desc_2_2"
      },
      {
        title: "ndsc_about_data_title_3",
        image: "icon_head_brains.svg",
        desc:
          "ndsc_about_data_desc_3_1",
        desc02:
          "ndsc_about_data_desc_3_2"
      },
      {
        title: "ndsc_about_data_title_4",
        image: "icon_checkboard_graph.svg",
        desc:
          "ndsc_about_data_desc_4_1",
        desc02:
          "ndsc_about_data_desc_4_2"
      }
    ],
    note: "ndsc_about_note"
  },
  categories: {
    title: "ndsc_categories_title",
    data: [{
      image: "icon_begineer.png",
      title: "ndsc_categories_date_title_1",
      list: [
        "ndsc_categories_date_desc_1_1",
        "ndsc_categories_date_desc_1_2"
      ]
    },
    {
      image: "icon_advanced.png",
      title: "ndsc_categories_date_title_2",
      list: [
        "ndsc_categories_date_desc_2_1",
        "ndsc_categories_date_desc_2_2"
      ]
    }]
  },
  guest: {
    title: 'ndsc_guest_title',
    list: [{
      date: 'ndsc_guest_item_1_date',
      name: 'ndsc_guest_item_1_name',
      desc: 'ndsc_guest_item_1_desc'
    }]
  },
  //Theme
  // theme: "Tema",
  // themeDesc:
  //   "Tema dari National Data Science Challenge 2020 adalah Spotting the Duplicates across Billion of Products in Millions of Stores, yakni sebuah tantangan untuk menghasilkan insightful knowledge dari volume data tekstual dan visual yang besar dengan menggunakan Machine Learning Analytics",
  // themeCategory01type: "Kategori Pemula (Beginner)",
  // themeCategory01:
  //   "Pencocokan Produk (Product Matching) berdasarkan Data Tekstual",
  // themeCategory01Li01:
  //   "Terbuka untuk siswa yang saat ini terdaftar di Sekolah Menengah Atas (SMA), Sekolah Menengah Kejuruan (SMK),atau Universitas di Indonesia (termasuk siswa pertukaran pelajar)",
  // themeCategory01Li02:
  //   "Pekerja dalam bidang non-teknologi yang bekerja di Indonesia dan tidak memiliki atau hanya mempunyai pengalaman sedikit dalam pemrograman dan/atau Data Science dan/atau Analisis Data",
  // themeCategory02type: "Kategori Lanjutan (Advanced)",
  // themeCategory02:
  //   "Pencocokan Produk (Product Matching) berdasarkan data Tekstual dan Visual",
  // themeCategory02Li01:
  //   "Mahasiswa Magister atau Doktor yang saat ini terdaftar di universitas di Indonesia (termasuk siswa pertukaran pelajar)",
  // themeCategory02Li02:
  //   "Semua pekerja dalam bidang teknologi yang bekerja di Indonesia.",
  // themeNote:
  //   "*Tim yang terdiri dari siswa dan pekerja akan ditinjau berdasarkan kasus-per-kasus (case-by-case basis) oleh tim internal Shopee. Kompetisi ini menggunakan dataset yang sudah tersedia untuk umum.",
  //prize
  prizes: "ndsc_prizes_title",
  prizesDesc: "ndsc_prizes_desc",
  currency: "ndsc_prizes_currency",
  team: "ndsc_prizes_team",
  prizesData: [
    {
      name: "ndsc_prizes_data_1_name",
      image: "icon_reward.svg",
      price: "ndsc_prizes_data_1_price",
      list: [
        "ndsc_prizes_data_1_desc",
      ]
    },
    {
      name: "ndsc_prizes_data_2_name",
      image: "icon_reward_silver.svg",
      price: "ndsc_prizes_data_2_price",
      list: ["ndsc_prizes_data_2_desc"]
    },
    {
      name: "ndsc_prizes_data_3_name",
      image: "icon_reward_copper.svg",
      price: "ndsc_prizes_data_3_price",
      list: ["ndsc_prizes_data_3_desc"]
    }
  ],
  prizesNote:
    "ndsc_prizes_note_1",
  prizesNote02:
    "ndsc_prizes_note_2",
  //Judge
  // judges: "Juri",
  by: "ndsc_training_by",
  // judgesDesc:
  //   "Para juri akan memilih tim dari masing-masing kategori dengan solusi yang terunik dan kreatif.",
  // judgesData: [
  //   {
  //     name: "Denny, S.Kom., M.I.T., Ph.D.",
  //     image: "judge-denny.jpg",
  //     link: "",
  //     title: "Direktur Fakultas Ilmu Komputer, Universitas Indonesia",
  //     desc:
  //       "Denny adalah Direktur Fakultas Ilmu Komputer di Universitas Indonesia yang mendapatkan gelar S3 nya dari Australian National University di tahun 2013. Riset pertamanya berhasil diterbitkan di Advances in Knowledge Discovery and Data Mining, dan sekarang beliau sudah menerbitkan lebih dari 10 riset berhubungan dengan Data Mining, Database Systems, dan Computational Intelligence. Beliau mengajar Advanced Algorithms, Data Structures, and Big Data courses."
  //   },
  //   {
  //     name: "Lektor Kepala Imas Sitanggang",
  //     image: "judge-imas.jpg",
  //     link: "",
  //     title: "Dosen Fakultas Ilmu Komputer, Institut Pertanian Bogor",
  //     desc:
  //       "Imas Sitanggang adalah Dosen Fakultas Ilmu Komputer di Institut Pertanian Bogor. Beliau memiliki minat yang kuat di Data Mining, Spatial Data Processing, dan aplikasinya terhadap model risiko kebakaran hutan dan lahan. Beliau dipercayai dengan berbagai tunjangan riset dari berbagai institusi dan aktif serta dalam program fellowship di bidangnya."
  //   },
  //   {
  //     name: "Ivan Wangsa",
  //     image: "judge-ivan.jpg",
  //     link: "",
  //     title: "Head of Business Intelligence, Shopee",
  //     desc:
  //       "Ivan Wangsa adalah Head of Business Intelligence di Shopee Indonesia, memimpin tim yang terdiri lebih dari 50 Data Analis dan Engineers dan memiliki fokus yang kuat pada data.  Setelah mendapatkan gelar sarjana Matematika dari Nanyang Technological University di Singapura, beliau memulai kariernya di Sea di tahun 2015, dengan pengalaman dari berbagai lini bisnis Sea (Corporate, Garena, Shopee, AirPay)."
  //   },
  //   {
  //     name: "Dr. Alexander Gunawan",
  //     image: "judge-alexander.jpg",
  //     link: "",
  //     title:
  //       "Ketua Jurusan, Teknik Informatika-Matematika dan Teknik Informatika-Statistika, Universitas Bina Nusantara",
  //     desc:
  //       "Dr. Alexander Gunawan adalah seorang Ilmuwan Komputer dan Ahli Matematika. Beliau memiliki minat untuk Artificial Intelligence dan mahir dalam Deep Learning dan kerangka Bayesian. Dalam disertasinya, beliau mengeksploitasi kerangka Bayesian untuk mengembangkan algoritma yang cepat dan optimal dalam Visual Object Tracking. Beliau juga memiliki wawasan dalam Industri Robotika dan Autonomous Mobile Robots, serta Natural Language Processing yang telah menuntunnya dalam beberapa riset mengenai subjek tersebut. Beliau juga rutin membuat ulasan untuk jurnal internasional."
  //   }
  // ],
  //Timeline
  timeline: "ndsc_timeline_title",
  timelineData: [
    {
      date: "ndsc_timeline_data_1_date",
      desc: "ndsc_timeline_data_1_desc"
    },
    {
      date: "ndsc_timeline_data_2_date",
      desc: "ndsc_timeline_data_2_desc"
    },
    // {
    //   date: "22 Feb 2020",
    //   desc: " Registrasi untuk Kompetisi ditutup"
    // },
    // {
    //   date: "21 Mar 2020",
    //   desc: "Hari H Kompetisi & Upacara Penghargaan"
    // }
  ],
  timelineNote: "ndsc_timeline_note",
  //training workshop
  trainingWorkshops: "ndsc_training_title",
  trainingDesc: "ndsc_training_desc",
  // trainingDescRegister: "Daftarkan diri Anda di",
  // link: "sini",
  trainingData: [
    {
      date: "ndsc_training_data_1_date",
      name: "ndsc_training_data_1_name",
      organizer: "ndsc_training_data_1_organizer",
      state: "",
      location: "ndsc_training_data_1_location",
      list: ["ndsc_training_data_1_desc"]
    },
    {
      date: "ndsc_training_data_2_date",
      name: "ndsc_training_data_2_name",
      organizer: "ndsc_training_data_2_organizer",
      state: "",
      location: "ndsc_training_data_2_location",
      list: [
        "ndsc_training_data_2_desc_1",
        "ndsc_training_data_2_desc_2"
      ]
    },
    {
      date: "ndsc_training_data_3_date",
      name: "ndsc_training_data_3_name",
      organizer: "ndsc_training_data_3_organizer",
      state: "",
      location: "ndsc_training_data_3_location",
      list: [
        "ndsc_training_data_3_desc_1",
        "ndsc_training_data_3_desc_2",
        "ndsc_training_data_3_desc_3",
        "ndsc_training_data_3_desc_4",
        "ndsc_training_data_3_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_4_date",
      name: "ndsc_training_data_4_name",
      organizer: "ndsc_training_data_4_organizer",
      state: "",
      location: "ndsc_training_data_4_location",
      list: [
        "ndsc_training_data_4_desc_1",
        "ndsc_training_data_4_desc_2",
        "ndsc_training_data_4_desc_3",
        "ndsc_training_data_4_desc_4",
        "ndsc_training_data_4_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_5_date",
      name: "ndsc_training_data_5_name",
      organizer: "ndsc_training_data_5_organizer",
      state: "",
      location: "ndsc_training_data_5_location",
      list: [
        "ndsc_training_data_5_desc_1",
        "ndsc_training_data_5_desc_2",
        "ndsc_training_data_5_desc_3",
        "ndsc_training_data_5_desc_4",
        "ndsc_training_data_5_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_6_date",
      name: "ndsc_training_data_6_name",
      organizer: "ndsc_training_data_6_organizer",
      state: "",
      location: "ndsc_training_data_6_location",
      list: ["ndsc_training_data_6_desc_1"]
    },
    {
      date: "ndsc_training_data_7_date",
      name: "ndsc_training_data_7_name",
      organizer: "ndsc_training_data_7_organizer",
      state: "",
      location: "ndsc_training_data_7_location",
      registerLink: "https://www.dicoding.com/academies/86",
      list: ["ndsc_training_data_7_desc_1"]
    },
    {
      date: "ndsc_training_data_8_date",
      name: "ndsc_training_data_8_name",
      organizer: "ndsc_training_data_8_organizer",
      state: "",
      location: "ndsc_training_data_8_location",
      registerLink:
        "https://sekolahkoding.com/track/belajar-python-bahasa-indonesia",
      list: [
        "ndsc_training_data_8_desc_1",
        "ndsc_training_data_8_desc_2",
        "ndsc_training_data_8_desc_3"
      ]
    },
    {
      date: "ndsc_training_data_9_date",
      name: "ndsc_training_data_9_name",
      organizer: "ndsc_training_data_9_organizer",
      location: "ndsc_training_data_9_location",
      state: "",
      list: [
        "ndsc_training_data_9_desc_1",
        "ndsc_training_data_9_desc_2",
        "ndsc_training_data_9_desc_3",
        "ndsc_training_data_9_desc_4",
        "ndsc_training_data_9_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_10_date",
      name: "ndsc_training_data_10_name",
      organizer: "ndsc_training_data_10_organizer",
      location: "ndsc_training_data_10_location",
      state: "",
      list: [
        "ndsc_training_data_10_desc_1",
        "ndsc_training_data_10_desc_2",
        "ndsc_training_data_10_desc_3",
        "ndsc_training_data_10_desc_4"
      ]
    },
    {
      date: "ndsc_training_data_11_date",
      name: "ndsc_training_data_11_name",
      organizer: "ndsc_training_data_11_organizer",
      location: "ndsc_training_data_11_location",
      state: "",
      list: [
        "ndsc_training_data_11_desc_1",
        "ndsc_training_data_11_desc_2",
        "ndsc_training_data_11_desc_3",
        "ndsc_training_data_11_desc_4"
      ]
    },
    {
      date: "ndsc_training_data_12_date",
      name: "ndsc_training_data_12_name",
      organizer: "ndsc_training_data_12_organizer",
      state: "",
      location: "ndsc_training_data_12_location",
      list: [
        "ndsc_training_data_12_desc_1",
        "ndsc_training_data_12_desc_2",
        "ndsc_training_data_12_desc_3",
        "ndsc_training_data_12_desc_4",
        "ndsc_training_data_12_desc_5",
        "ndsc_training_data_12_desc_6"
      ]
    },
    {
      date: "ndsc_training_data_13_date",
      name: "ndsc_training_data_13_name",
      organizer: "ndsc_training_data_13_organizer",
      state: "",
      location: "ndsc_training_data_13_location",
      list: [
        "ndsc_training_data_13_desc_1",
        "ndsc_training_data_13_desc_2",
        "ndsc_training_data_13_desc_3",
        "ndsc_training_data_13_desc_4",
        "ndsc_training_data_13_desc_5",
        "ndsc_training_data_13_desc_6",
        "ndsc_training_data_13_desc_7",
        "ndsc_training_data_13_desc_8",
        "ndsc_training_data_13_desc_9",
        "ndsc_training_data_13_desc_10",
        "ndsc_training_data_13_desc_11",
        "ndsc_training_data_13_desc_12",
        "ndsc_training_data_13_desc_13"
      ]
    },
    {
      date: "ndsc_training_data_14_date",
      name: "ndsc_training_data_14_name",
      organizer: "ndsc_training_data_14_organizer",
      state: "",
      location: "ndsc_training_data_14_location",
      list: ["ndsc_training_data_14_desc_1", "ndsc_training_data_14_desc_2"]
    },
    {
      date: "ndsc_training_data_15_date",
      name: "ndsc_training_data_15_name",
      organizer: "ndsc_training_data_15_organizer",
      state: "",
      location: "ndsc_training_data_15_location",
      list: [
        "ndsc_training_data_15_desc_1",
        "ndsc_training_data_15_desc_2",
        "ndsc_training_data_15_desc_3",
        "ndsc_training_data_15_desc_4",
        "ndsc_training_data_15_desc_5",
        "ndsc_training_data_15_desc_6",
        "ndsc_training_data_15_desc_7",
        "ndsc_training_data_15_desc_8",
        "ndsc_training_data_15_desc_9"
      ]
    },
    {
      date: "ndsc_training_data_16_date",
      name: "ndsc_training_data_16_name",
      organizer: "ndsc_training_data_16_organizer",
      state: "",
      location: "ndsc_training_data_16_location",
      list: [
        "ndsc_training_data_16_desc_1",
        "ndsc_training_data_16_desc_2",
        "ndsc_training_data_16_desc_3",
        "ndsc_training_data_16_desc_4",
        "ndsc_training_data_16_desc_5",
        "ndsc_training_data_16_desc_6"
      ]
    },
    {
      date: "ndsc_training_data_17_date",
      name: "ndsc_training_data_17_name",
      organizer: "ndsc_training_data_17_organizer",
      state: "",
      location: "ndsc_training_data_17_location",
      list: [
        "ndsc_training_data_17_desc_1",
        "ndsc_training_data_17_desc_2",
        "ndsc_training_data_17_desc_3",
        "ndsc_training_data_17_desc_4"
      ]
    },
    {
      date: "ndsc_training_data_18_date",
      name: "ndsc_training_data_18_name",
      organizer: "ndsc_training_data_18_organizer",
      state: "",
      location: "ndsc_training_data_18_location",
      list: [
        "ndsc_training_data_18_desc_1",
        "ndsc_training_data_18_desc_2",
        "ndsc_training_data_18_desc_3",
        "ndsc_training_data_18_desc_4",
        "ndsc_training_data_18_desc_5",
        "ndsc_training_data_18_desc_6"
      ]
    },
    {
      date: "ndsc_training_data_19_date",
      name: "ndsc_training_data_19_name",
      organizer: "ndsc_training_data_19_organizer",
      state: "",
      location: "ndsc_training_data_19_location",
      list: [
        "ndsc_training_data_19_desc_1",
        "ndsc_training_data_19_desc_2",
        "ndsc_training_data_19_desc_3",
        "ndsc_training_data_19_desc_4",
        "ndsc_training_data_19_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_20_date",
      name: "ndsc_training_data_20_name",
      organizer: "ndsc_training_data_20_organizer",
      state: "",
      location: "ndsc_training_data_20_location",
      list: [
        "ndsc_training_data_20_desc_1",
        "ndsc_training_data_20_desc_2",
        "ndsc_training_data_20_desc_3",
        "ndsc_training_data_20_desc_4",
        "ndsc_training_data_20_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_21_date",
      name: "ndsc_training_data_21_name",
      organizer: "ndsc_training_data_21_organizer",
      state: "",
      location: "ndsc_training_data_21_location",
      list: [
        "ndsc_training_data_21_desc_1",
        "ndsc_training_data_21_desc_2",
        "ndsc_training_data_21_desc_3"
      ]
    },
    {
      date: "ndsc_training_data_22_date",
      name: "ndsc_training_data_22_name",
      organizer: "ndsc_training_data_22_organizer",
      state: "",
      location: "ndsc_training_data_22_location",
      list: [
        "ndsc_training_data_22_desc_1",
        "ndsc_training_data_22_desc_2",
        "ndsc_training_data_22_desc_3",
        "ndsc_training_data_22_desc_4",
        "ndsc_training_data_22_desc_5"
      ]
    },
    {
      date: "ndsc_training_data_23_date",
      name: "ndsc_training_data_23_name",
      organizer: "ndsc_training_data_23_organizer",
      state: "",
      location: "ndsc_training_data_23_location",
      list: [
        "ndsc_training_data_23_desc_1",
        "ndsc_training_data_23_desc_2"
      ]
    },
    {
      date: "ndsc_training_data_24_date",
      name: "ndsc_training_data_24_name",
      organizer: "ndsc_training_data_24_organizer",
      state: "",
      location: "",
      list: [
        "ndsc_training_data_24_desc_1",
        "ndsc_training_data_24_desc_2",
        "ndsc_training_data_24_desc_3"
      ]
    }
  ],
  // Register
  register: "ndsc_register",
  // registerNow: "Daftar Sekarang",
  registerURL: "https://techatshopee.formstack.com/forms/ndscid_2020",
  // registerDuration:
  //   "Registrasi dibuka pada tanggal 2 Desember 2019 dan akan ditutup pada tanggal 22 Februari 2020.*",
  // registerGoing01: "Apakah anda ingin mencari suatu tantangan baru?",
  // registerGoing02:
  //   "Apakah anda ingin memecahkan masalah seperti seorang Data Science?",
  registerClose: "ndsc_register_close",
  registerNow: 'ndsc_register_now',
  // registerClose01: "Regitrasi akan ditutup pada tanggal 22 Februari 2020.*",
  // registerClose02:
  //   "Unfortunately, registration for the National Data Science Challenge 2020 has closed.",
  // registerClose03: "Do look forward to our future events!",
  // registerClose04:
  //   "Participants who confirmed after 26 February 2020 will not be eligible to take part in the competition.",
  // registerNote:
  //   "*Shopee memiliki hak untuk tidak menerima pendaftaran setelah jumlah pendaftar memenuhi kapasitas maksimum lokasi.",
  //partner
  partners: "ndsc_partners_title",
  organized: "ndsc_partners_organized_title",
  organizedData: [
    {
      name: "Shopee",
      image: "shopee_logo_en.png",
      link: "https://careers.shopee.co.id/"
    }
  ],
  hostedBy: "ndsc_partners_hostedBy_title",
  hostedByData: [
    {
      name: "ndsc_partners_hostedBy_data_1_name",
      image: "ristek_logo.png",
      link: "https://ristekdikti.go.id/"
    }
  ],
  trainingPartners: "ndsc_partners_training_title",
  trainingPartnersData: [
    {
      name: "ndsc_partners_training_data_1_name",
      image: "binar_acaemdy_logo.png",
      link: "https://binar.co.id/"
    },
    {
      name: "ndsc_partners_training_data_2_name",
      image: "hacktiv8_logo.png",
      link: "https://hacktiv8.com/"
    },
    {
      name: "ndsc_partners_training_data_3_name",
      image: "universitas_id_logo.png",
      link: "https://www.cs.ui.ac.id/?lang=en"
    },
    {
      name: "ndsc_partners_training_data_4_name",
      image: "dicoding_logo.png",
      link: "https://www.dicoding.com/"
    },
    {
      name: "ndsc_partners_training_data_5_name",
      image: "dqlab_logo.png",
      link: "https://www.dqlab.id/"
    },
    {
      name: "ndsc_partners_training_data_6_name",
      image: "arkademy_logo.png",
      link: "https://www.arkademy.com/"
    },
    {
      name: "ndsc_partners_training_data_7_name",
      image: "makeai_logo.png",
      link: "https://make-ai.id/"
    },
    {
      name: "ndsc_partners_training_data_8_name",
      image: "bitlabs_logo.png",
      link: "https://bitlabs.id/"
    },
    {
      name: "ndsc_partners_training_data_9_name",
      image: "botika_logo.png",
      link: "https://botika.online/"
    },
    {
      name: "ndsc_partners_training_data_10_name",
      image: "sekolah_koding_logo.png",
      link: "https://sekolahkoding.com/"
    },
    {
      name: "ndsc_partners_training_data_11_name",
      image: "clevio_logo.png",
      link: "http://clev.io/"
    },
    {
      name: "ndsc_partners_training_data_12_name",
      image: "koding_next_logo.png",
      link: "https://kodingnext.com/"
    },
    {
      name: "ndsc_partners_training_data_13_name",
      image: "g2academy_logo.png",
      link: "https://www.g2academy.co/"
    },
    {
      name: "ndsc_partners_training_data_14_name",
      image: "LOGO DATA ACADEMY-01.png",
      link: "https://cybertrend-intra.com/academy/"
    },
    {
      name: "ndsc_partners_training_data_15_name",
      image: "algorit.png",
      link: "https://algorit.ma/"
    },
    {
      name: "ndsc_partners_training_data_16_name",
      image: "skilvul.png",
      link: "https://skilvul.com/"
    },
    {
      name: "ndsc_partners_training_data_17_name",
      image: "course-net.png",
      link: "https://www.course-net.com/"
    }
  ],
  universityPartners: "ndsc_university_title",
  universityPartnersData: [
    {
      name: "ndsc_partners_university_data_1_name",
      image: "universitas_id_logo.png",
      link: "https://www.cs.ui.ac.id/?lang=en"
    },
    {
      name: "ndsc_partners_university_data_2_name",
      image: "Institut_teknologi_bandung_logo.png",
      link: "https://www.itb.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_3_name",
      image: "ciputra_logo.png",
      link: "https://www.uc.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_4_name",
      image: "busocs_logo.png",
      link: "https://socs.binus.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_5_name",
      image: "its_logo.png",
      link: "https://www.its.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_6_name",
      image: "kalbis_logo.png",
      link: "http://kalbis.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_7_name",
      image: "binus_university_logo.png",
      link: "https://binus.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_8_name",
      image: "umn_logo.png",
      link: "https://www.umn.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_9_name",
      image: "universitas_airlangga_logo.png",
      link: "https://www.unair.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_10_name",
      image: "uph_logo.png",
      link:
        "https://www.uph.edu/faculty/school-of-information-science-technology/"
    },
    {
      name: "ndsc_partners_university_data_11_name",
      image: "telkom_logo.png",
      link: "https://telkomuniversity.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_12_name",
      image: "pancasila_logo.png",
      link: "http://www.univpancasila.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_13_name",
      image: "padjajaran_logo.png",
      link: "http://www.unpad.ac.id/en"
    },
    {
      name: "ndsc_partners_university_data_14_name",
      image: "president_logo.png",
      link: "https://www.president.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_15_name",
      image: "komputer_indonesia_logo.png",
      link: "https://www.unikom.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_16_name",
      image: "teknologi_logo.png",
      link: "https://www.del.ac.id/?lang=en"
    },
    {
      name: "ndsc_partners_university_data_17_name",
      image: "politeknik_logo.png",
      link: "https://pcr.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_18_name",
      image: "ipb_logo.png",
      link: "https://ipb.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_19_name",
      image: "atmajaya_jakarta.png",
      link: "https://www.atmajaya.ac.id/web/"
    },
    {
      name: "ndsc_partners_university_data_20_name",
      image: "atmajaya_yogjakarta_logo.png",
      link: "http://www.uajy.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_21_name",
      image: "katolik_logo.png",
      link: "http://unpar.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_22_name",
      image: "informatika_unpar_logo.png",
      link: "http://informatika.unpar.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_23_name",
      image: "ubm_logo.png",
      link: "https://www.ubm.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_24_name",
      image: "petra_logo.png",
      link: "http://www.petra.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_25_name",
      image: "brawijaya_logo.png",
      link: "https://ub.ac.id/"
    },
    {
      name: "ndsc_partners_university_data_26_name",
      image: "ukdw.png",
      link: "https://www.ukdw.ac.id/"
    }
  ],
  supportPartners: "ndsc_support_title",
  supportPartnersData: [
    {
      name: "ndsc_partners_support_data_1_name",
      image: "dsi_logo.png",
      link: "https://datascience.or.id/"
    },
    {
      name: "ndsc_partners_support_data_2_name",
      image: "phthon_id_logo.png",
      link: "https://www.pythonindo.com/"
    },
    {
      name: "ndsc_partners_support_data_3_name",
      image: "she_loves_data_logo.png",
      link: "https://shelovesdata.com/"
    },
    {
      name: "ndsc_partners_support_data_4_name",
      image: "aidi_logo.png",
      link: "https://aidi.id/"
    },
    {
      name: "ndsc_partners_support_data_5_name",
      image: "rid_logo.png",
      link: "https://www.meetup.com/r-indonesia/"
    },
    {
      name: "ndsc_partners_support_data_6_name",
      image: "fb_dev_circle_logo.png",
      link: "https://www.facebook.com/groups/DevCJakarta/"
    },
    {
      name: "ndsc_partners_support_data_7_name",
      image: "codepolitan_logo.png",
      link: "https://www.codepolitan.com/"
    },
    {
      name: "ndsc_partners_support_data_8_name",
      image: "idqa_logo.png",
      link: "http://www.isqa.club/"
    },
    {
      name: "ndsc_partners_support_data_9_name",
      image: "go_jakarta_logo.png",
      link: "https://www.meetup.com/GoJakarta/members/"
    },
    {
      name: "ndsc_partners_support_data_10_name",
      image: "reactjs_id_logo.png",
      link: "https://reactjs.id/"
    },
    {
      name: "ndsc_partners_support_data_11_name",
      image: "devops_id_logo.png",
      link: "https://www.meetup.com/DevOps-Indonesia/"
    },
    {
      name: "ndsc_partners_support_data_12_name",
      image: "impact_byte_logo.png",
      link: "https://impactbyte.com/"
    },
    {
      name: "ndsc_partners_support_data_13_name",
      image: "jagoan_coding_logo.png",
      link: "https://jagoancoding.com/"
    },
    {
      name: "ndsc_partners_support_data_14_name",
      image: "teknologi_id_logo.png",
      link: "https://teknologi.id/"
    },
    {
      name: "ndsc_partners_support_data_15_name",
      image: "robot_surabaya_logo.png",
      link: "https://www.instagram.com/robot_surabaya/"
    },
    {
      name: "ndsc_partners_support_data_16_name",
      image: "petani_kode_logo.png",
      link: "https://www.petanikode.com/"
    },
    {
      name: "ndsc_partners_support_data_17_name",
      image: "komunitas_robot_logo.png",
      link: "https://www.facebook.com/KomunitasRobot/"
    },
    {
      name: "ndsc_partners_support_data_18_name",
      image: "dt_logo.png",
      link: "https://www.instagram.com/deeptech.id/"
    },
    {
      name: "ndsc_partners_support_data_19_name",
      image: "inovator_muda_id_logo.png",
      link: "https://www.instagram.com/inovatormuda.id/"
    },
    {
      name: "ndsc_partners_support_data_20_name",
      image: "arduino_id_logo.png",
      link: "https://www.meetup.com/ArduinoIndonesia/"
    },
    {
      name: "ndsc_partners_support_data_21_name",
      image: "jakarta_js_logo.png",
      link: "https://www.meetup.com/JakartaJS/"
    },
    {
      name: "ndsc_partners_support_data_22_name",
      image: "id_big_data_logo.png",
      link: "https://idbigdata.com/official/"
    },
    {
      name: "ndsc_partners_support_data_23_name",
      image: "microservice_logo.png",
      link: "https://www.meetup.com/Microservice-JKT/"
    },
    {
      name: "ndsc_partners_support_data_24_name",
      image: "coding_bee_logo.png",
      link: "https://www.codingbee.org/"
    },
    {
      name: "ndsc_partners_support_data_25_name",
      image: "koding_indonesia_logo.png",
      link: "https://www.kodingindonesia.com/"
    },
    {
      name: "ndsc_partners_support_data_26_name",
      image: "kotakode.png",
      link: "https://kotakode.com/"
    }
  ],
  studentPartners: "ndsc_student_title",
  studentPartnersData: [
    {
      name: "ndsc_partners_student_data_1_name",
      image: "bncc_logo.png",
      link: "https://bncc.net/"
    },
    {
      name: "ndsc_partners_student_data_2_name",
      image: "bemfib_logo.png",
      link: "https://www.instagram.com/bemfibui/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_3_name",
      image: "binus_tv_logo.png",
      link: "http://www.binus.tv/"
    },
    {
      name: "ndsc_partners_student_data_4_name",
      image: "binus_game_logo_2.png",
      link: "http://scdc.binus.ac.id/bgdc"
    },
    {
      name: "ndsc_partners_student_data_5_name",
      image: "lembaga_logo.png",
      link: "https://psikologi.ugm.ac.id/lembaga-mahasiswa-psikologi/"
    },
    {
      name: "ndsc_partners_student_data_6_name",
      image: "himapsi_logo.png",
      link: "https://himapsifpuaj.wordpress.com/"
    },
    {
      name: "ndsc_partners_student_data_7_name",
      image: "himstat_logo.png",
      link: "https://www.instagram.com/himstat/"
    },
    {
      name: "ndsc_partners_student_data_8_name",
      image: "himsisfo_logo.png",
      link: "https://www.instagram.com/himsisfo_binus/"
    },
    {
      name: "ndsc_partners_student_data_9_name",
      image: "himka_logo.png",
      link: "https://www.instagram.com/himka_binus/"
    },
    {
      name: "ndsc_partners_student_data_10_name",
      image: "himtek_logo.png",
      link: "https://www.instagram.com/himtek.binus/"
    },
    {
      name: "ndsc_partners_student_data_11_name",
      image: "himtes_logo.png",
      link: "https://www.instagram.com/himtesbinus/"
    },
    {
      name: "ndsc_partners_student_data_12_name",
      image: "bpreneur_logo.png",
      link: "https://www.instagram.com/b.preneur/"
    },
    {
      name: "ndsc_partners_student_data_13_name",
      image: "benc_logo_2.png",
      link: "https://www.instagram.com/binusenglishclub/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_14_name",
      image: "himmcomm_logo.png",
      link: "https://www.instagram.com/himmcommbinus/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_15_name",
      image: "cyber_security_logo.png",
      link: "https://www.instagram.com/cscbinus/"
    },
    {
      name: "ndsc_partners_student_data_16_name",
      image: "himmat_logo.png",
      link: "https://www.instagram.com/himmat_binus/"
    },
    {
      name: "ndsc_partners_student_data_17_name",
      image: "bem_logo.png",
      link: "https://www.instagram.com/bem.itdel/"
    },
    {
      name: "ndsc_partners_student_data_18_name",
      image: "dca_itdel_logo.png",
      link: "https://www.facebook.com/DelCyberArmy/"
    },
    {
      name: "ndsc_partners_student_data_19_name",
      image: "himator_itdel_logo.png",
      link: "http://instagram.com/himator_itdel/"
    },
    {
      name: "ndsc_partners_student_data_20_name",
      image: "drc_itdel_logo.png",
      link: "http://instagram.com/drc_itdel/"
    },
    {
      name: "ndsc_partners_student_data_21_name",
      image: "himasti_itdel_logo.png",
      link: "https://www.instagram.com/himasti_itdel/"
    },
    {
      name: "ndsc_partners_student_data_22_name",
      image: "himsi_itdel_logo.png",
      link: "https://www.instagram.com/himsi.itdel_/"
    },
    {
      name: "ndsc_partners_student_data_23_name",
      image: "himatek_itdel_logo.png",
      link: "https://www.instagram.com/himatek.itdel/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_24_name",
      image: "crossover_itdel_logo.png",
      link: "https://www.instagram.com/crossover.ukm.del/"
    },
    {
      name: "ndsc_partners_student_data_25_name",
      image: "himatera_itdel_logo.png",
      link: "http://instagram.com/himademtika/"
    },
    {
      name: "ndsc_partners_student_data_26_name",
      image: "delpro_itdel_logo.png",
      link: "https://www.instagram.com/delproclub/"
    },
    {
      name: "ndsc_partners_student_data_27_name",
      image: "himatif_itdel_logo.png",
      link: "https://www.instagram.com/himatif.itdel/"
    },
    {
      name: "ndsc_partners_student_data_28_name",
      image: "hme_itdel_logo.png",
      link: "http://hme.del.ac.id/"
    },
    {
      name: "ndsc_partners_student_data_29_name",
      image: "himalkom_ipb_logo.png",
      link: "https://www.instagram.com/himalkomipb/"
    },
    {
      name: "ndsc_partners_student_data_30_name",
      image: "gsb_ipb_logo.png",
      link: "https://www.instagram.com/gsb_ipb/"
    },
    {
      name: "ndsc_partners_student_data_31_name",
      image: "bem_its_logo.png",
      link: "https://www.instagram.com/bemfv_its/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_32_name",
      image: "mekatronika_logo.png",
      link: "https://www.instagram.com/hmpstem/"
    },
    {
      name: "ndsc_partners_student_data_33_name",
      image: "tif_unpar_logo.png",
      link: "http://instagram.com/hmpstif_unpar/"
    },
    {
      name: "ndsc_partners_student_data_34_name",
      image: "lkm_unpar_logo.png",
      link: "https://www.instagram.com/lkm_unpar/"
    },
    {
      name: "ndsc_partners_student_data_35_name",
      image: "pm_unpar_logo.png",
      link: "https://www.instagram.com/lkm_unpar/"
    },
    {
      name: "ndsc_partners_student_data_36_name",
      image: "matematika_unpar_logo.png",
      link: "https://www.instagram.com/hmpsma.unpar/?hl=en"
    },
    {
      name: "ndsc_partners_student_data_37_name",
      image: "himti_logo.png",
      link: "https://www.instagram.com/himtiug/"
    },
    {
      name: "ndsc_partners_student_data_38_name",
      image: "bem_fti_its.png",
      link: "https://www.instagram.com/bemfti_its/"
    }
  ],
  //faq
  faq: "ndsc_faq_title",
  faqTitle01: "ndsc_faq_title_1",
  faqData01: [
    {
      question: "ndsc_faq_1_question_1",
      answer: "ndsc_faq_1_answer_1"
    },
    {
      question: "ndsc_faq_1_question_2",
      answer: "ndsc_faq_1_answer_2"
    },
    {
      question: "ndsc_faq_1_question_3",
      answer: "ndsc_faq_1_answer_3"
    }
  ],
  faqTitle02: "ndsc_faq_title_2",
  faqData02: [
    {
      question:
        "ndsc_faq_2_question_1",
      answer:
        "ndsc_faq_2_answer_1"
    },
    {
      question: "ndsc_faq_2_question_2",
      answer: "ndsc_faq_2_answer_2"
    },
    {
      question: "ndsc_faq_2_question_3",
      answer: "ndsc_faq_2_answer_3"
    }
  ],
  faqTitle03: "ndsc_faq_title_3",
  faqData03: [
    {
      question: "ndsc_faq_3_question_1",
      answer: "ndsc_faq_3_answer_1"
    },
    {
      question: "ndsc_faq_3_question_2",
      answer: "ndsc_faq_3_answer_2"
    },
    {
      question: "ndsc_faq_3_question_3",
      answer: "ndsc_faq_3_answer_3"
    },
    {
      question: "ndsc_faq_3_question_4",
      answer: "ndsc_faq_3_answer_4"
    },
    {
      question: "ndsc_faq_3_question_5",
      answer: "ndsc_faq_3_answer_5"
    },
    {
      question: "ndsc_faq_3_question_6",
      answer: "ndsc_faq_3_answer_6"
    },
    {
      question: "ndsc_faq_3_question_7",
      answer: "ndsc_faq_3_answer_7"
    }
  ],
  faqTitle04: "ndsc_faq_title_4",
  faqData04: [
    {
      question: "ndsc_faq_4_question_1",
      answer: "ndsc_faq_4_answer_1"
    },
    {
      question: "ndsc_faq_4_question_2",
      answer: "ndsc_faq_4_answer_2"
    }
  ],
  //contact
  contactDesc01: "ndsc_contact_desc_1",
  contactBtn: "ndsc_contact_btn",
  contactDesc02: "ndsc_contact_desc_2",
  contactEmail: "ndsc.id@shopee.com",
  contactDesc03: "ndsc_contact_desc_3",
  //footer
  instagram: "Instagram",
  instagramLink: "https://www.instagram.com/LifeatShopee",
  linkedin: "LinkedIn",
  linkedinLink: "https://linkedin.com/company/Shopee",
  career: "ndsc_nav_career",
  careerLink: "https://careers.shopee.co.id/",
  copyright: "ndsc_footer_copyright",
  termsAndCondition: "ndsc_t&c",

  //Popup
  // popup: {
  //   content: `
  //   <p>
  //   Berkaitan dengan situasi virus Corona (Covid-19) di Jakarta, pemerintah provinsi memberikan saran kepada para penyelenggara acara untuk membatalakan atau menunda acara-acara yang diadakan dalam skala besar. 
  //   </p>
  //   <p>
  //   Perihal acara National Data Science Challenge 2020, Shopee dengan sangat menyesal memutuskan untuk <b>menunda sampai ada pemberitahuan lebih lanjut</b>. Hal ini kami lakukan karena kami menaruh prioritas kesehatan setiap orang yang akan datang dan yang terlibat di dalamnya.
  //   </p>
  //   <p>
  //   Jika Anda sudah mendaftarkan diri dan sudah RSVP, Shopee akan mengirimkan email pemberitahuan lebih lanjut untuk proses selanjutnya. Terima kasih atas dukungan dan perhatiannya. 
  //   </p>
  //   `
  // },
  gallery
};

export default translations;
